export interface IRequestReviewEnvelope {
  requestReviewsDto: IRequestReview[];
  requestReviewCount: number;
}

export interface IRequestReview {
  id: string;
  requestId: string;

  address: string;
  age: number;
  consentDate: Date | null;
  dA15589User: boolean;
  dataElementCode: string;
  decisionBy: string;
  dob: Date;
  documentDate: Date;
  name: string;
  noteCount: number;
  portLOADate: Date | null;
  portRequest: boolean;
  spanishRequest: boolean;
  provider: string;
  recommendationBy: string;
  registrationRequestID: string;
  requestCaseID: number;
  selfCertificationDate: Date | null;
  status: string;
  reviewStatus: string;
  supportingFile: string;
  supportingFileByteStream: string;
  tdn: string;
  serviceType: string;
  transactionType: string;
  reviewEnd: Date | null;
  reviewStart: Date;
}

export class IRequestReviewSubmitForm {
  id: string = "";
  result: string = "";
  escalation: string = "";

  constructor(id?: string, result?: string, escalation?: string) {
    if (id) {
      this.id = id;
    }
    if (result) {
      this.result = result;
    }
    if (escalation) {
      this.escalation = escalation;
    }
    Object.assign(this);
  }
}

export class IRequestReviewCreateForm {
  requestId: string = "";

  constructor(init?: IRequestReview, requestId?: string) {
    if (init) {
      this.requestId = init!.requestId;
    }

    if (requestId) {
      this.requestId = requestId;
    }
    Object.assign(this);
  }
}
